import React, { useState } from "react"
import CustomCard from "components/Atoms/CustomCard"
import TablePagination from "components/Molecules/TablePagination"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { RESET_SELECT_ALL } from "store/selector.redux"
import { useDispatch } from "react-redux"
import CustomButton from "components/Atoms/CustomButton"
import AssignDockDialog from "./AssignDockDialog"
import DateSelector from "components/Templates/DateSelector"

const DmsTableHeader = ({ children }) => {
  const [{ date, search, page }, setFilter] = useSearchFilter()
  const dispatch = useDispatch()

  const [isOpenAssignDock, setOpenAssignDock] = useState(false)

  return (
    <div className="p-3">
      <CustomCard className="p-0">
        <ModuleHeader
          white={true}
          borderBottom="none"
          header={<Description icon="truck" title="Vehicle loading" />}
          query={search}
          onQueryChange={query => {
            setFilter(prev => ({
              ...prev,
              search: query,
              page: 0,
            }))
          }}
        >
          <TablePagination
            className="mr-3"
            page={page}
            onPageChange={pg => {
              setFilter(prev => ({
                ...prev,
                page: pg,
              }))
              if (pg > page) {
                dispatch({
                  type: RESET_SELECT_ALL,
                  path: "dms",
                })
              }
            }}
          />
          <DateSelector
            value={date}
            onChange={(_, date) => {
              setFilter(prev => ({
                ...prev,
                date,
              }))
            }}
          />
          <CustomButton
            intent="primary"
            text="Assign dock"
            onClick={() => setOpenAssignDock(true)}
          />
        </ModuleHeader>
        <AssignDockDialog
          isOpen={isOpenAssignDock}
          onClose={() => setOpenAssignDock(false)}
        />
        {children}
      </CustomCard>
    </div>
  )
}

export default DmsTableHeader
